<template>
  <div class="mt-4">
    <h1 class="title has-text-left">Test Centres</h1>
    <h3 class="subtitle has-text-left">Find a Test Centre near you and book your
      CITB Health, Safety and Environment Test (commonly referred to as a
      CITB Touch Screen Test) required to apply for a CSCS Card.</h3>
    <div id="search-bar">
      <b-field label="Please enter postcode so we can find the nearest test centre for you">
      </b-field>
      <b-field>
        <b-input v-model="term" expanded placeholder="Enter postcode"></b-input>
        <b-button @click="searchCenter">Search</b-button>
      </b-field>
    </div>
    <div class="box custom-width mx-auto" v-for="(center, index) in results" :key="index">
      <div v-if="index === 0">
      <CenterCard nearest :center="center" />
      </div>
      <div v-else>
      <CenterCard :center="center" />
      </div>
    </div>
  </div>
</template>

<script>

import CenterCard from '@/components/CenterCard.vue';
import { centers } from '@/assets/data';
import { createSnackbar } from '@/common';
import { mapActions } from 'vuex';

export default {
  name: 'CenterList',
  components: {
    CenterCard,
  },
  data() {
    return {
      results: centers,
      centers,
      term: '',
    };
  },
  created() {
    this.$on('results', (results) => {
      this.results = results;
    });
  },
  methods: {
    ...mapActions(['getNearestTestCenters', 'setLocation']),
    createSnackbar,
    async searchCenter() {
      if (this.term.length > 5) {
        try {
          const result = await this.getNearestTestCenters(this.term);
          this.results = result;
        } catch (error) {
          this.createSnackbar('Postcode not found!');
        }
      }
    },
  },
};
</script>

<style scoped>

  #search-bar {
    margin: 3em auto;
    max-width: 85%;
  }
  .mt-4 {
    margin-top: 2em;
  }

  @media (min-width: 932px) {
    .box.custom-width {
        width: 70%;
    }
  }
</style>
